export default __webpack_public_path__ + "static/media/arrow-right.65f1581b.svg";